module.exports = __webpack_public_path__ + "static/media/pic4.8f1661f5.jpg";